import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import logo from "../images/dc_logo.png";
import logovc from "../images/loginbg.jpg";
import "./Login.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const { login } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            navigate("/");
        }
    }, [navigate]);

    const returnUrl = location.state?.returnUrl || "/";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");

        try {
            const response = await axios.post(`${BASE_URL}/login.php`, { email, password });
            const data = await response.data;

            if (data.success) {
                login(data.user);
                alert("Login successful!");
                navigate(returnUrl, { replace: true });
            } else {
                setErrorMessage(data.error || "Invalid credentials. Please try again.");
            }
        } catch (error) {
            console.error("Login error:", error);
            setErrorMessage("Something went wrong. Please try again later.");
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const decoded = jwtDecode(credentialResponse.credential);
            console.log(decoded);
            const response = await axios.post(`${BASE_URL}/google_login.php`, {
                email: decoded.email,
                name: decoded.name,
                google_id: decoded.sub
            });

            const data = await response.data;

            if (data.success) {
                login(data.user);
                alert("Login successful!");
                navigate(returnUrl, { replace: true });
            } else {
                setErrorMessage(data.error || "Google login failed. Please try again.");
            }
        } catch (error) {
            console.error("Google login error:", error);
            setErrorMessage("Something went wrong with Google login. Please try again.");
        }
    };

    const handleGoogleError = () => {
        setErrorMessage("Google login failed. Please try again.");
    };

    return (
        <GoogleOAuthProvider clientId="987740287283-ba8246b7otfcnb9eqk3obe5u675i8vfe.apps.googleusercontent.com">
            <div className="login-bg">
                <div className="login-container">
                    <div className="login-box">
                        <div className="logo">
                            <img src={logo} alt="Logo" />
                        </div>
                        <form className="login-form" onSubmit={handleSubmit}>
                            <h1>Login</h1>
                            <div className="input-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>
                            <div className="input-group">
                                <label htmlFor="password">Password</label>
                                <div className="email-verify">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter your password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="show-password-btn"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>
                            {errorMessage && <p className="error-message">{errorMessage}</p>}
                            <div className="already-have-account">
                                <p>Don't have an account? <a href="/#/register" className="redirect-link">Register</a></p>
                            </div>
                            <div className="already-have-account">
                                <p>Forgot your password? <a href="/#/forgot-password" className="redirect-link">Reset Password</a></p>
                            </div>

                            <button type="submit" className="login-button">Login</button>

                            <div className="google-login-container">
                                <p>Or login with:</p>
                                <GoogleLogin
                                    onSuccess={handleGoogleSuccess}
                                    onError={handleGoogleError}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="logo-vc-area">
                        <img src={logovc} alt="logo_vector" />
                    </div>
                </div>
            </div>
        </GoogleOAuthProvider>
    );
}

export default Login;